import { Typography } from '@mui/material';
import type { BillingInterval, Currency, UsageProductInput } from '@vy/types';
import { isNullOrUndefined } from '@vy/utils';
import React from 'react';
import { UsageProductItem } from './UsageProductItem/UsageProductItem';

type UsageProductsSectionProps = {
  usageProducts: UsageProductInput[];
  billingInterval: BillingInterval;
  currency: Currency;
  title?: string;
};

export const UsageProductsSection: React.FC<UsageProductsSectionProps> = ({
  usageProducts,
  billingInterval,
  currency,
  title,
}) => {
  return (
    <section>
      <Typography
        variant="overline"
        sx={{
          color: "text.secondary",
          fontWeight: 300
        }}>
        {isNullOrUndefined(title) ? 'Usage-based Fees' : title}
      </Typography>
      <ul className="mt-4 space-y-8">
        {usageProducts.map((product) => (
          <li key={product.id}>
            <UsageProductItem product={product} billingInterval={billingInterval} currency={currency} />
          </li>
        ))}
      </ul>
    </section>
  );
};
